import createAnimationWrapper from "./createAnimationWrapper";

const anim = {
 '0%, 60%': {
  easing: `cubic-bezier(0.3,0,1,0.7)`
 },
 '0%': {
  opacity: 1,
  transform: `rotate(0) scale(1)`
 },
 '0.1%': {
  opacity: 0,
  transform: `rotate(-1800deg) scale(.3)`
 },
 '100%, 60%': {
  opacity: 1,
  transform: `rotate(0) scale(1)`
 }
};

export default createAnimationWrapper(anim, {
    duration: "1s",
    easing: "linear",
    loop: true,
     direction: "alternate",
     delay: "1s"
});

